export default __webpack_public_path__ + "../images/slider-3.png";